import { Component, ElementRef, Input, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ModalController, ToastController } from '@ionic/angular';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { AuthService } from 'src/app/services/auth.service';
import { ConfigService } from 'src/app/services/config.service';
import { ToolsService } from 'src/app/services/tools.service';

@Component({
  selector: 'app-otp-verification-modal',
  templateUrl: './otp-verification-modal.component.html',
  styleUrls: ['./otp-verification-modal.component.scss'],
})
export class OtpVerificationModalComponent implements OnInit, OnDestroy {

  @Input() method: 'sms' | 'email' = 'sms';
  @Input() destination: string = '';

  digits: string[] = ['', '', '', ''];
  loading: boolean = false;

  @ViewChildren('digitInput') digitInputs!: QueryList<ElementRef>;

  resendCountdown: number = 30;
  canResend: boolean = false;
  timerInterval: any;
  resending: boolean = false;
  captcha: any;

  constructor(
    private modalCtrl: ModalController,
    private authService: AuthService,
    private toastCtrl: ToastController,
    private recaptchaV3Service: ReCaptchaV3Service,
    private configService: ConfigService,
    private toolsService: ToolsService
  ) {}

  ngOnInit() {
    this.startResendTimer();
  }

  ngOnDestroy() {
    this.clearTimer();
  }


  trackByFn(index: number): number {
    return index;
  }

  onDigitInput(event: any, index: number) {
    const inputEl = event.target as HTMLInputElement;
    const value = inputEl.value;

    if (value && !/^\d+$/.test(value)) {
      this.digits[index] = '';
      inputEl.value = '';
      return;
    }

    if (value) {
      this.digits[index] = value.slice(-1);
      inputEl.value = this.digits[index];

      if (index < 3) {
        setTimeout(() => {
          const nextInput = this.digitInputs.toArray()[index + 1];
          if (nextInput) {
            nextInput.nativeElement.focus();
            nextInput.nativeElement.select();
          }
        }, 10);
      }
    }
  }


  onKeyDown(event: KeyboardEvent, index: number) {
    if (event.key === 'Backspace') {
      if (!this.digits[index] && index > 0) {
        setTimeout(() => {
          const prevInput = this.digitInputs.toArray()[index - 1];
          if (prevInput) {
            prevInput.nativeElement.focus();
          }
        }, 10);
      }
    }
  }

  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    const pastedData = event.clipboardData?.getData('text').trim() || '';
    if (/^\d{4}$/.test(pastedData)) {
      this.digits = pastedData.split('');
      setTimeout(() => {
        const lastInput = this.digitInputs.toArray()[3];
        if (lastInput) {
          lastInput.nativeElement.focus();
        }
      }, 10);
    }
  }

  get isCodeComplete(): boolean {
    return this.digits.every((d) => d.trim() !== '');
  }

  cancel() {
    this.modalCtrl.dismiss({ verified: false });
  }

  async verifyCode() {
    if (!this.isCodeComplete) return;

    const otpCode = this.digits.join('');
    this.loading = true;

    try {
      const response = await this.authService.validateCode(otpCode);
      this.loading = false;
      this.modalCtrl.dismiss({ verified: true, data: response });
    } catch (error) {
      this.loading = false;
      this.toolsService.presentErrorToast('Código incorrecto o expirado. Inténtalo de nuevo.');
    }
  }

  startResendTimer() {
    this.canResend = false;
    this.resendCountdown = 30;

    this.clearTimer();
    this.timerInterval = setInterval(() => {
      this.resendCountdown--;
      if (this.resendCountdown <= 0) {
        this.canResend = true;
        this.clearTimer();
      }
    }, 1000);
  }

  clearTimer() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }

  async resendCode() {
    if (!this.canResend || this.resending || this.loading) return;

    this.resending = true;

    await this.validateCaptcha()

    try {
      const data = {
        document: localStorage.getItem('document_number'),
        type_document: localStorage.getItem('document_type'),
        method: this.method,
        captcha: this.captcha,
      };

      await this.authService.sendCode(data);

      this.resending = false;
      this.toolsService.presentSucessToast('Código reenviado exitosamente.');

      this.startResendTimer();
    } catch (error) {
      this.resending = false;
      this.toolsService.presentErrorToast('Error al reenviar el código. Inténtalo de nuevo más tarde.');
    }
  }

  validateCaptcha() {
    if (this.configService.mall?.captcha_token) {
      this.recaptchaV3Service.execute('login').subscribe((token: string) => {
        this.captcha = token;
      });
    }
  }
}
